import { useProduct } from "@/components/pdp/PdpDataContext";

// HP3 — trust-badge marquee under the hero. Reuses the exact PDP3.2/V3.1
// single-row editorial marquee treatment (unframed icon + label chips, slow
// auto-scroll, hover-pause, respects prefers-reduced-motion) but without the
// "Skincare Facts" heading — just the credibility strip. Badges come from the
// shared product `highlights.items` (official Riversol content).
const Chip = ({ item }) => (
  <div className="shrink-0 flex items-center gap-4 px-7 py-4" aria-hidden="true">
    <span className="flex items-center justify-center rounded-full bg-riversol-blue/[0.06] shrink-0 w-12 h-12">
      <img src={item.icon} alt="" className="w-[22px] h-[22px]" loading="lazy" />
    </span>
    <span className="font-medium text-neutral-800 whitespace-nowrap text-[14px]">
      {item.label}
    </span>
  </div>
);

export const TrustBadgeMarqueeV3 = () => {
  const P = useProduct();
  const items = P?.highlights?.items;
  if (!items?.length) return null;

  return (
    <section
      className="bg-white border-b border-neutral-200 py-6 lg:py-8"
      data-testid="home-trust-marquee-v3"
      aria-label="Product credibility highlights"
    >
      <div className="relative overflow-hidden group">
        <div
          className="flex items-center animate-marquee-editorial [animation-play-state:running] group-hover:[animation-play-state:paused] motion-reduce:animate-none"
          style={{ width: "max-content" }}
        >
          {[...items, ...items, ...items].map((item, i) => (
            <Chip key={`tb-${i}`} item={item} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
};

export default TrustBadgeMarqueeV3;
